import { render } from "./AppOverlays.vue?vue&type=template&id=ba51c840"
const script = {}

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__